import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TvPurchaseRedirectModalData {
  action: 'subscribe' | 'rent';
  title?: string;
}

@Component({
  selector: 'app-tv-purchase-redirect-modal',
  templateUrl: './tv-purchase-redirect-modal.component.html',
  styleUrls: ['./tv-purchase-redirect-modal.component.css']
})
export class TvPurchaseRedirectModalComponent {
  constructor(
    public dialogRef: MatDialogRef<TvPurchaseRedirectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TvPurchaseRedirectModalData
  ) {}

  get heading(): string {
    return this.data.action === 'subscribe' ? 'Subscribe to continue' : 'Rent to continue';
  }

  get message(): string {
    const titleClause = this.data.title ? ` "${this.data.title}"` : '';
    if (this.data.action === 'subscribe') {
      return `To subscribe and unlock${titleClause}, please open the Toqqer app on your phone or visit homecinemaplus.tv from your browser.`;
    }
    return `To rent${titleClause}, please open the Toqqer app on your phone or visit homecinemaplus.tv from your browser.`;
  }

  close(): void {
    this.dialogRef.close();
  }
}
